// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__pN0bT","spin":"styles_spin__mwTyF","center":"styles_center__NGp0B"};